// extracted by mini-css-extract-plugin
export default {"arrowButtons":"ButtonsZone_arrowButtons__xsbg8","iconButton":"ButtonsZone_iconButton__XVbKA"};